import { render, staticRenderFns } from "./ChecklisttypeFields.vue?vue&type=template&id=f1b862ce"
import script from "./ChecklisttypeFields.vue?vue&type=script&lang=js"
export * from "./ChecklisttypeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports